module.exports = __webpack_public_path__ + "resources/img/img_gridgain_apache3_m_en.af8566db204c530d58cd09e97a7bf6b4.png";